import Pill from 'ext-ui/components/Pill/Pill'
import { tag_colorTagDefaultText } from 'ext-ui/style/colors'
import ArrowIcon from 'ext-ui/svg/icon/ArrowIcon'
import React, { ReactElement } from 'react'
import SvgEmail from 'src/components/Svgs/SvgEmail'
import UserAvatar from 'src/components/UserAvatar/UserAvatar'
import { AvatarSizes, OrganizationRoles } from 'src/enums'
import { useTranslate } from 'src/localization/Trns'
import { orgRoleDisplayTitle } from 'src/utils/roles.utils'

import type { AssignmentVariant } from '../ConfirmCardAssignmentModal'
import * as style from './RecipientHeader.style'

const initialsFor = (displayName: string | null, email: string): string => {
  if (displayName) {
    return displayName
      .split(/\s+/)
      .filter(Boolean)
      .slice(0, 2)
      .map((part) => part.charAt(0))
      .join('')
      .toUpperCase()
  }
  return email.charAt(0).toUpperCase()
}

export interface RecipientHeaderProps {
  variant: AssignmentVariant
  email: string
  name?: string | null
  avatarUrl?: string | null
  currentRole?: OrganizationRoles | null
}

const RecipientHeader: React.FC<RecipientHeaderProps> = ({
  variant,
  email,
  name,
  avatarUrl,
  currentRole,
}): ReactElement => {
  const translate = useTranslate()

  const displayName = name?.trim() || null

  return (
    <div css={style.container}>
      <div css={style.identity}>
        <UserAvatar
          size={AvatarSizes.Large}
          user={{
            id: email,
            fullNameOrEmail: displayName ?? email,
            initials: initialsFor(displayName, email),
            avatarUrl: avatarUrl ?? undefined,
          }}
        />
        <div css={style.text}>
          {displayName ? (
            <>
              <span css={style.name}>{displayName}</span>
              <span css={style.email}>{email}</span>
            </>
          ) : (
            <span css={style.name}>{email}</span>
          )}
        </div>
      </div>
      <div css={style.pills}>
        {variant === 'newInvite' && (
          <Pill>
            <span css={style.newInvite}>
              <SvgEmail
                width={16}
                height={16}
                viewBox="0 0 24 24"
                fill={tag_colorTagDefaultText}
              />
              {translate('New Invite')}
            </span>
          </Pill>
        )}
        {variant === 'promote' && currentRole && (
          <>
            <Pill>{translate(orgRoleDisplayTitle(currentRole))}</Pill>
            <ArrowIcon direction="right" aria-hidden="true" css={style.arrow} />
            <Pill>{translate('Card Manager')}</Pill>
          </>
        )}
        {variant === 'elevated' && currentRole && (
          <Pill>{translate(orgRoleDisplayTitle(currentRole))}</Pill>
        )}
      </div>
    </div>
  )
}

export default RecipientHeader
